import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const TITLE_NAME = "Title";
const [TitleProvider, useTitleContext] = buildGlobalReferenceContext(TITLE_NAME);

export { TitleProvider, useTitleContext };
//# sourceMappingURL=context.mjs.map
